import { render, staticRenderFns } from "./DocumentTypeTaxonomyNew.vue?vue&type=template&id=85468e42&"
import script from "./DocumentTypeTaxonomyNew.vue?vue&type=script&lang=ts&"
export * from "./DocumentTypeTaxonomyNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports